import styled from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const Content = styled.div`
  padding: 0 0rem 1rem;

  &.nowrap {
    white-space: nowrap;
    overflow: hidden;

    @media (max-width: ${TABLET_WIDTH}px) {
      overflow: auto;
    }
  }
`;


export const ButtonScroll = styled.div`
  color: red;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  background: white;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  width: 4rem;
  cursor: pointer;
  left: ${props => (props.direction === 'left' ? '-6rem' : 'auto')};
  right: ${props => (props.direction === 'left' ? 'auto' : '-6rem')};
  top: calc(50% - 2rem);
  position: absolute;

  @media (max-width: ${TABLET_WIDTH}px) {
    display: none;
  }

  img {
    padding: 4rem;
    &.left{
      transform: rotate(180deg);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/SimpleCarousel/components/styles.js